<template>
  <highcharts :options="chartOptions" />
</template>

<script>
import { merge, first, get } from 'lodash';
import defaultOptions from '../default-chart-options';

export default {
  props: {
    priceHistoryWeek: {
      type: Array,
      default: () => [],
    },
    intentionPrice: {
      type: Number,
    },
  },

  data() {
    return {
      options: {
        chart: {
          width: 60,
          height: 23,
          reflow: false,
          spacingTop: 0,
          spacingRight: 0,
          spacingBottom: 0,
          spacingLeft: 0,
          plotBorderWidth: 0,
          margin: [0, 0, 0, 0],
        },
        plotOptions: {
          series: {
            marker: {
              enabled: true,
              symbol: 'circle',
              radius: 0.5,
            },
          },
        },
      },
    };
  },

  computed: {
    values() {
      if (this.intentionPrice) {
        return [...this.priceHistoryWeek, this.intentionPrice];
      }
      return this.priceHistoryWeek;
    },

    chartOptions() {
      return merge({}, defaultOptions, this.yAxisOptions, this.options, {
        series: [{ data: this.values }],
      });
    },

    allValuesEqual() {
      const firstValue = first(this.values);
      return this.values.every(val => val === firstValue);
    },

    yAxisOptions() {
      if (this.allValuesEqual) {
        // straight line, so place it in the middle of the chart
        return {
          yAxis: {
            max: get(this.values, '0', 0) * 2,
          },
        };
      }
      return {
        yAxis: {
          min: Math.min(...this.values.filter(v => v !== null)) * 0.98,
          max: Math.max(...this.values.filter(v => v !== null)) * 1.02,
        },
      };
    },
  },
};
</script>
